import { SendcloudRegion } from "@redotech/redo-model/carrier-account/carrier-account";
import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";

// Stub form. Sendcloud BYOA onboarding lands in a follow-up PR; the modal
// hides the Sendcloud card via getFilteredCarrierOptions until then. This
// file exists so the exhaustiveness checks in carrier-input.ts and
// add-carrier-modal.tsx have something to point at.

export const SendcloudCarrierInput = groupInput({
  region: input<SendcloudRegion>({ validator: nonEmptyValidator }),
  publicKey: input<string>({ validator: nonEmptyValidator }),
  secretKey: input<string>({ validator: nonEmptyValidator }),
});

export type SendcloudCarrierValue = InputProvider.Value<
  typeof SendcloudCarrierInput
>;

export type SendcloudCarrierForm = InputProvider.Form<
  typeof SendcloudCarrierInput
>;

export const SendcloudCarrierDefault = (): SendcloudCarrierValue => ({
  region: SendcloudRegion.EU,
  publicKey: "",
  secretKey: "",
});

export const CreateSendcloudCarrierForm = memo(
  function CreateSendcloudCarrierForm(_props: {
    carrierInput: SendcloudCarrierForm;
  }) {
    return null;
  },
);
